// UI CONFIGS
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { Breakpoint } from "@mui/material";
import {
  ThemeDirectionTypes,
  ThemeModeTypes,
  ThemeOrientation,
} from "theme/index";

export interface ThemeConfigTypes {
  themeStretch: Breakpoint;
  themeDirection: ThemeDirectionTypes;
  themeMode: ThemeModeTypes;
  themeOrientation: ThemeOrientation;
}

export const ThemeConfig: ThemeConfigTypes = {
  themeStretch: "xl",
  themeDirection: "rtl",
  themeMode: "light",
  themeOrientation: "horizontal",
};

export const THEME_COOKIE_KEY = "theme";

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
  LOGO_SIZE: {
    width: 150,
    height: 50,
  },
};
export const NAVBAR = {
  // pages
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  // dashboard
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
  DASHBOARD_HORIZONTAL_NAVBAR_HEIGHT: 44,
};

export const BOTTOM_NAVIGATION = {
  BOTTOM_NAVIGATION_HEIGHT: 82,
  // BOTTOM_NAVIGATION_HEIGHT: 64,
  BOTTOM_NAVIGATION_ICON: 20,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};
export const LOGO = {
  NAVBAR_LOGO: { width: 120, height: 30 },
  NAVBAR_LOGO_COLLAPSED: { width: 60, height: 24 },
};

// SERVICES CONFIGS
export const BASE_URL = process.env.REACT_APP_BASE_URL;
// process.env.REACT_APP_LOCAL_DEVELOPEMENT === "true"
//   ? process.env.REACT_APP_LOCAL_BASE_URL
//   : process.env.REACT_APP_BASE_URL;

export enum METHODS {
  get = "GET",
  post = "POST",
  put = "PUT",
  patch = "PATCH",
}

export const FIREBASE = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};
export const REACT_APP_VAPID_KEY = process.env.REACT_APP_VAPID_KEY;
export const FIREBASE_PUSH_TOKEN = process.env.REACT_APP_PUSH_TOKEN;
